import { IAlertTypeData } from "@home-health-notify/domain";
import { AlertWidgetWrapper } from "../Alert.style";
import ReferralAlertHeader from "../alertItemHeader/ReferralAlertHeader";
import ReferralAlertContent from "./ReferralAlertContent";

const ReferralAlert = ({
  counter,
  alerts: referralAlert,
}: {
  counter: number;
  alerts: IAlertTypeData;
}) => {
  return (
    <AlertWidgetWrapper>
      <ReferralAlertHeader counter={counter} />
      <ReferralAlertContent referralData={referralAlert.data} />
    </AlertWidgetWrapper>
  );
};

export default ReferralAlert;
